import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-vehicle-help',
  templateUrl: './vehicle-help.component.html',
  styleUrls: ['./vehicle-help.component.scss']
})
export class VehicleHelpComponent implements OnInit, AfterViewChecked {
  translateText=['Close','Print','Vehicle Sessions','helpText1','The','Dates','helpText2','Start Time','helpText3','Dealer Code','helpText4','Technician','helpText5','State column','helpText6','helpText7','The field is empty','This means it can be any of','Automatically indicted by IDS','Hotline indictment','TechnicianMechanic indictment','Automatically indicted by IDS but the VCM was disconnected during the session','Automatically indicted by IDS but the VMM was disconnected during the session','In which the RVC for the session is empty.','In the instance of RVC(T), a potential RVC output of RVC=0 will not be shown on the screen.','A 13 character string beginning with an','This is showing you the RVC that was generated for this session.','No RVC required','This is showing you that the indictment was an RVC(A) and for the repair to be completed','Labour','This is showing you that the indictment was an RVC(T) for a labor only operation.','Major assembly','helpText8','No RVC available','This indicates an error in that the method of indictment has not been seen before and should be investigated.','Method','column shows the method in which the session indictment occurred. Use the table below to understand what it is showing you and why.','The session was automatically indicted by the IDS system.','The session was indicted by using the Hotline for indictment approval.','The session was manually indicted by the technicianmechanic.','The session was automatically indicted by the IDS system and no RVC is required.','The session was automatically indicted by the IDS system but the VCM was disconnected from the vehicle during the session.','The session was automatically indicted by the IDS system but the VMM was disconnected or not connected to the system during the session when it was needed.','RVC(A, No VCM)','RVC(A, No VMM)']
  translatedText:any=[]
  
  constructor(private translate: TranslateService, private activateRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe(data => {
      this.translate.use(data["language"].toLowerCase());
    })
    this.getTranslations();
  }

  ngAfterViewChecked() {
    document.title = 'Ford Etis How to Help Page';
  }

  getTranslations(){
    for(let item of this.translateText){
      this.translate.get(item).subscribe((text)=>{
        this.translatedText.push(this.translate.instant(text))
      });
    } 
  }

  closePage(){
    window.close();
  }

  printPage(){
    window.print();
  }

}
